<template>
	<div class="action-notes">
		<div>
			<template v-if="newNoteType === 'single-invoice'">
				<div>
					<h4 class="mb-25">{{ $t('makeNote') }}</h4>
				</div>
				<new-note :type="'invoice'" :recipient-prop="recipient" :legal-entity-prop="legalEntity" :single="true"></new-note>
			</template>
			<template v-if="newNoteType === 'multi-invoice'">
				<div>
					<h4 class="mb-25">{{ $t('makeNote') }}</h4>
				</div>
				<new-note :type="'invoice'" :recipient-prop="recipient" :legal-entity-prop="legalEntity"></new-note>
			</template>
			<template v-if="newNoteType === 'recipient'">
				<div>
					<h4 class="mb-25">{{ $t('makeNote') }}</h4>
				</div>
				<new-note :type="'recipient'" :recipient-prop="recipient" :legal-entity-prop="legalEntity"></new-note>
			</template>
		</div>
		<div class="disp-flex filterLine">
			<h4>{{ $t('latestActions') }}</h4>
			<div class="ml-auto">{{ $t('showSystemActions') }} <el-switch v-model="showSystemNotes"> </el-switch></div>
		</div>
		<div class="disp-flex filterLine ">
			<el-select v-model="channelFilterSelection" collapse-tags multiple size="mini" :placeholder="$t('statusFilter')">
				<el-option v-for="item in CONSTANTS.ACTIONNOTES_TYPES" :key="item" :label="$translate.action_and_note(item)" :value="item" />
			</el-select>
			<LoadingButton size="mini" type="primary" :execute="applyFilters">{{ $t('applyFilters') }}</LoadingButton>
		</div>
		<div class="disp-flex filterLine">
			<el-input v-model="searchTerm" size="mini" placeholder="" @keyup.enter.native="onSearch">
				<i slot="prefix" class="el-input__icon el-icon-search"></i>
			</el-input>
		</div>
		<div class="displ-flex mb-25">
			<el-tag v-for="invoice in selectedInvoices"
				:key="invoice.reference"
				:closable="true"
				size="small"
				class="cursor-pointer mr-10 mb-10"
				type="info"
				@close="handleRemoveSelectedInvoice(invoice)">
				{{ invoice.document_number }}
			</el-tag>
		</div>
		<template v-if="actionsNotes && actionsNotes.length >= 1">
			<timeline
				v-if="actionsNotes && actionsNotes.length > 0"
				:show-load-more="actionsNotes.length !== totalActionsNotes"
				:timeline-items="actionsNotes"
				@loadMore="handleLoadMore"
			>
				<el-timeline-item
					v-for="(actionNote) in actionsNotes"
					:key="actionNote.reference"
				>
					{{ actionNote }}
				</el-timeline-item>
			</timeline>
		</template>
		<template v-else-if="actionsNotes && actionsNotes.length === 0">
			{{ $t('noData') }}
		</template>
		<template v-else>
			{{ $t('loading') }}
		</template>
	</div>
</template>

<script>
import { EventBus } from '@/eventBus';
import Timeline from '@/components/Timeline';
import NewNote from '@/components/_Note/NewNote';
import { mapGetters } from 'vuex';
import gql from 'graphql-tag';
import * as CONSTANTS from '@/constants';
import LoadingButton from '@/components/_Buttons/LoadingButton.vue';
import Logging from '@/logging';

export default {
	components: {
		Timeline,
		NewNote,
		LoadingButton
	},
	props: {
		legalEntity: { type: String, required: true },
		recipient: { type: String, required: true }
	},
	data() {
		return {
			showSystemNotes: false,
			showRecpNewNote: undefined,
			actionsNotes: undefined,
			totalActionsNotes: undefined,
			searchTerm: '',
			limit: 20,
			channelFilterSelection: undefined
		};
	},
	computed: {
		...mapGetters(['selectedParticipantStore', 'selectedInvoices', 'newNoteType']),
		queryVars: function() {
			return {
				participant: this.selectedParticipantStore,
				recipient: this.recipient,
				qSystemNotes: this.showSystemNotes,
				channels: this.channelFilterSelection,
				limit: this.limit,
				offset: 0
			};
		},
		CONSTANTS() {
			return CONSTANTS;
		},
		single() {
			return this.selectedInvoices && this.selectedInvoices.length === 1;
		}
	},
	watch: {
		recipient() {
			this.fetch();
		},
		selectedParticipantStore() {
			this.fetch();
		},
		selectedInvoices() {
			this.fetch();
		},
		showSystemNotes() {
			this.fetch();
		},
		limit() {
			this.fetch();
		}
	},
	created() {
		this.channelFilterSelection = CONSTANTS.ACTIONNOTES_TYPES; // this.$store.getters.invoiceTableStatusFilter;
		this.fetch();
		EventBus.$on('refetchActionsNotes', () => {
			this.fetch();
		});
	},
	methods: {
		fetch() {
			Logging.log('ActionNotes.actionsAndNotesQueryInvoice - QueryVars: ', this.queryVars);

			if (this.selectedParticipantStore) {
				this.queryVars.participant = this.selectedParticipantStore;

				var actualQueryVars = this.queryVars;
				actualQueryVars.invoices = this.selectedInvoices.length > 0 ? this.selectedInvoices.map(i => i.document_number) : null;

				if (this.newNoteType === 'single-invoice' || this.newNoteType === 'multi-invoice') {
					Logging.log('ActionNotes.actionsAndNotesQueryInvoice');

					return this.$apollo
						.query({
							query: this.actionsAndNotesQueryInvoice(),
							variables: actualQueryVars
						})
						.then(result => {
							Logging.log('Result GET_ACTIONS_AND_NOTES_INVOICE: ', result);
							if (result.data && result.data.actions_notes && result.data.total) {
								this.actionsNotes = result.data.actions_notes;
								this.totalActionsNotes = result.data.total.aggregate.count;
							} else {
								throw new Error('Incorrect query result GET_ACTIONS_AND_NOTES');
							}
						})
						.catch(e => {
							Logging.error('Error GET_ACTIONS_AND_NOTES: ', e);
						});
				} else {
					Logging.log('ActionNotes.actionsAndNotesQuery');
					return this.$apollo
						.query({
							query: this.actionsAndNotesQuery(this.searchTerm),
							variables: actualQueryVars
						})
						.then(result => {
							Logging.log('Result GET_ACTIONS_AND_NOTES: ', result.data.actions_notes);
							if (result.data && result.data.actions_notes && result.data.total) {
								this.actionsNotes = result.data.actions_notes;
								Logging.log('Result this.actionsNotes: ', this.actionsNotes);
								Logging.log('Result result.data.actions_notes: ', result.data.actions_notes);
								this.totalActionsNotes = result.data.total.aggregate.count;
							} else {
								throw new Error('Incorrect query result GET_ACTIONS_AND_NOTES');
							}
						})
						.catch(e => {
							Logging.error('Error GET_ACTIONS_AND_NOTES: ', e);
						});
				}
			} else {
				return;
			}
		},
		applyFilters() {
			return this.fetch();
		},
		handleLoadMore() {
			this.limit = this.limit + 10;
		},
		onSearch() {
			this.fetch();
		},
		handleRemoveSelectedInvoice(invoice) {
			let invoices = this.selectedInvoices.filter(i => i.reference !== invoice.reference);

			this.$store.dispatch('risolto/setSelectedInvoices', invoices);
		},
		//	TODO: combine both queries in one query
		actionsAndNotesQuery(searchTerm) {
			var searchtermFilters = '';
			if (searchTerm && searchTerm !== '') {
				searchtermFilters = `
				 note_by_reference: {
					_or: [
						{ note: { _ilike: "${searchTerm}" } }
						{ note_invoices: { invoice_by_reference: {invoice_number: {_eq: "${searchTerm}"}} } }
					]
				}
				`;
			}

			var query = gql`
query find_latest_action_and_notes(
  $offset: Int = 0
  $limit: Int = 5
  $participant: uuid!
  $recipient: uuid!
  $invoices: [String!]
  $channels: [String!]
  $qSystemNotes: Boolean
) {
  total: risolto_virtual_action_and_note_v4_aggregate(
    args: {
      q_participant: $participant
      q_recipient: $recipient
      q_system_notes: $qSystemNotes
    }
    where: {
      _and: {
        channel: { _in: $channels }
        ${searchtermFilters}
        _or: [
          { note_by_reference: { recipient: { _eq: $recipient } } }
          {
            note_by_reference: {
              note_invoices: { invoice_by_reference: { invoice_number: { _in: $invoices } } }
            }
          }
          {
            action_by_reference: {
              _or: [
                { action_invoices: { invoice_by_reference: { invoice_number: { _in: $invoices } } } }
                { primary_invoice_by_reference: { invoice_number: { _in: $invoices } } }
              ]
            }
          }
          { action_by_reference: { recipient: { _eq: $recipient } } }
          { invoice_dispute_by_reference: { recipient: { _eq: $recipient } } }
          { invoice_dispute_by_reference: { invoice_by_reference: { invoice_number: { _in: $invoices } } } }
        ]
      }
    }
  ) {
    aggregate {
      count
    }
  }
  actions_notes: risolto_virtual_action_and_note_v4(
    offset: $offset
    limit: $limit
    args: {
      q_participant: $participant
      q_recipient: $recipient
      q_system_notes: $qSystemNotes
    }
    where: {
      _and: {
        channel: { _in: $channels }
        ${searchtermFilters}
        _or: [
          { note_by_reference: { recipient: { _eq: $recipient } } }
          {
            note_by_reference: {
              note_invoices: { invoice_by_reference: { invoice_number: { _in: $invoices } } }
            }
          }
          {
            action_by_reference: {
              _or: [
				{ action_invoices: { invoice_by_reference: { invoice_number: { _in: $invoices } } } }
                { primary_invoice_by_reference: { invoice_number: { _in: $invoices } } }
              ]
            }
          }
          { action_by_reference: { recipient: { _eq: $recipient } } }
          { invoice_dispute_by_reference: { recipient: { _eq: $recipient } } }
          { invoice_dispute_by_reference: { invoice_by_reference: { invoice_number: { _in: $invoices } } } }
        ]
      }
    }
  ) {
    reference: v_reference
    participant
    legal_entity
    recipient
    recipient_by_reference {
      reference
      name
    }
    action
    action_by_reference {
      notes {
        reference
        note
        category
      }
      cancel_reason
      canceler_by_reference {
        username
      }
      executed_by_reference {
        username
      }
      primary_invoice
      primary_invoice_by_reference {
        invoice_number
      }
      zip_code1: metadata(path: "channels[0].to.address.zip_code")
      zip_code2: metadata(path: "channels[0].to.zip_code")
      action_interchanges {
        interchange_by_reference {
          barcode
          channel
          interchange_events(order_by: { last_event_timestamp: desc }) {
            v_reference
            event_type
            interchange_by_reference {
              interchange_event {
                reference
                event_type
                created_at
              }
            }
            event_type_count
            last_event_timestamp
            email: channel_endpoint(path: "$.email")
            postal_mail: channel_endpoint(path: "postal_mail")
			channel_endpoint
          }
        }
      }
      executed_at
      action_invoices {
        reference
        invoice_by_reference {
          reference
          invoice_number
        }
      }
    }
    note
    system_note
    note_by_reference {
      action_by_reference {
        channel
      }
      note
      note_invoices {
        invoice_by_reference {
          reference
          invoice_number
        }
      }
	  original_note
      created_by
    }
    invoice_dispute
    invoice_dispute_by_reference {
      auto_resolved
      from
      until
      dispute_code_by_reference {
        code
      }
      resolved_at
      resolved_by
      resolved_by_by_reference {
        username
      }
      invoice_by_reference {
        reference
        invoice_number
      }
      tasks {
        canceled_at
        canceled_by_by_reference {
          username
        }
        executed_at
        executed_by_by_reference {
          username
        }
        assignee
        assignee_by_reference {
          username
        }
      }
    }
    person_by_reference {
      reference
      username
    }
    created_at
    updated_at
    channel
    metadata
    status
    message_code
    created_by
  }
}
`;
			Logging.log('ActionNotes.actionsAndNotesQuery - query: ', query);
			return query;
		},
		actionsAndNotesQueryInvoice(searchTerm) {
			var searchtermFilters = '';
			if (searchTerm && searchTerm !== '') {
				searchtermFilters = `
				 note_by_reference: {
					_or: [
						{ note: { _ilike: "${searchTerm}" } }
						{ note_invoices: { invoice_by_reference: { invoice_number: {_eq: "${searchTerm}"}} } } 
					]
				}
				`;
			}
			var query = gql`
query find_latest_action_and_notes_invoice(
  $offset: Int = 0
  $limit: Int = 5
  $participant: uuid!
  $recipient: uuid!
  $invoices: [String!]
  $channels: [String!]
  $qSystemNotes: Boolean
) {
  total: risolto_virtual_action_and_note_v4_aggregate(
    args: {
      q_participant: $participant
      q_recipient: $recipient
      q_system_notes: $qSystemNotes
    }
    where: {
      _and: {
        ${searchtermFilters}
        channel: { _in: $channels }
        _or: [
          {
            note_by_reference: {
              note_invoices: { invoice_by_reference: { invoice_number: { _in: $invoices } } } 
            }
          }
          {
            action_by_reference: {
              _or: [
                { action_invoices: { invoice_by_reference: { invoice_number: { _in: $invoices } } } }
                { primary_invoice_by_reference: { invoice_number: { _in: $invoices } } } 
              ]
            }
          }
          { invoice_dispute_by_reference: { invoice_by_reference: { invoice_number: { _in: $invoices } } } }
        ]
      }
    }
  ) {
    aggregate {
      count
    }
  }
  actions_notes: risolto_virtual_action_and_note_v4(
    offset: $offset
    limit: $limit
    args: {
      q_participant: $participant
      q_recipient: $recipient
      q_system_notes: $qSystemNotes
    }
    where: {
      _and: {
        ${searchtermFilters}
        channel: { _in: $channels }
        _or: [
          {
            note_by_reference: {
              note_invoices: { invoice_by_reference: { invoice_number: { _in: $invoices } } }
            }
          }
          {
            action_by_reference: {
              _or: [
                { action_invoices: { invoice_by_reference: { invoice_number: { _in: $invoices } } } }
                { primary_invoice_by_reference: { invoice_number: { _in: $invoices } } }
              ]
            }
          }
          { invoice_dispute_by_reference: { invoice_by_reference: { invoice_number: { _in: $invoices } } } }
        ]
      }
    }
  ) {
    created_at
    updated_at
    reference: v_reference
    participant
    legal_entity
    recipient
    recipient_by_reference {
      reference
      name
    }
    action
    action_by_reference {
      notes {
        note
        category
        reference
      }
      canceler_by_reference {
        username
      }
      executed_by_reference {
        username
      }
      created_at
      primary_invoice
      primary_invoice_by_reference {
        invoice_number
      }
      action_interchanges(order_by: { created_at: desc }) {
        interchange_by_reference {
          barcode
          channel
          interchange_events(order_by: { last_event_timestamp: desc }) {
            v_reference
            event_type
            interchange_by_reference {
              interchange_event {
                reference
                event_type
                created_at
              }
            }
            event_type_count
            last_event_timestamp
            email: channel_endpoint(path: "$.email")
            postal_mail: channel_endpoint(path: "postal_mail")
          }
        }
      }
      executed_at
      action_invoices {
        reference
        invoice_by_reference {
          reference
          invoice_number
        }
      }
    }
    note
    note_by_reference {
      action_by_reference {
        channel
      }
      note
      note_invoices {
        invoice_by_reference {
          reference
          invoice_number
        }
      }
      created_by
    }
    invoice_dispute
    invoice_dispute_by_reference {
      auto_resolved
      from
      until
      dispute_code_by_reference {
        code
      }
      resolved_at
      resolved_by
      resolved_by_by_reference {
        username
      }
      invoice_by_reference {
        reference
        invoice_number
      }
      tasks {
        canceled_at
        canceled_by_by_reference {
          username
        }
        executed_at
        executed_by_by_reference {
          username
        }
        assignee
        assignee_by_reference {
          username
        }
      }
    }
    person_by_reference {
      reference
      username
    }
    created_at
    updated_at
    channel
    metadata
    status
    message_code
    created_by
  }
}
`;
			Logging.log('ActionNotes.actionsAndNotesQueryInvoice: ', query);
			return query;
		}
	}
};
</script>

<style scoped>
	.timelineitem {
		margin-bottom: -8px;
		font-size: 13px;
	}
	.filterLine {
		justify-content: space-between;
		margin-bottom: 10px;
		align-items: center;
	}

</style>
